import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-944455a4")

_pushScopeId("data-v-944455a4")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("其他测试")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("测试统计")
const _hoisted_3 = { class: "toolbar-right" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("导出 JSON")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("总任务统计")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("不同任务类型测试次数统计")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("皮肤测试次数统计")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("皮肤不同类型测试次数统计")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_empty = _resolveComponent("el-empty")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_main, null, {
        default: _withId(() => [
          _createVNode(_component_el_breadcrumb, {
            "separator-class": "el-icon-arrow-right",
            class: "PosTitle"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_breadcrumb_item, null, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_el_breadcrumb_item, null, {
                default: _withId(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.dateRange,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dateRange = $event)),
                  type: "daterange",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  "value-format": "YYYY-MM-DD",
                  clearable: false,
                  size: "small",
                  onChange: _ctx.handleDateChange
                }, null, 8, ["modelValue", "onChange"]),
                _createVNode(_component_el_button, {
                  onClick: _ctx.handleExport,
                  type: "primary",
                  size: "small",
                  disabled: !_ctx.statisticsData
                }, {
                  default: _withId(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_divider),
          _withDirectives(_createVNode("div", null, [
            _createVNode(_component_el_card, { class: "tableMinH" }, {
              default: _withId(() => [
                (_ctx.statisticsData)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_el_divider, { "content-position": "left" }, {
                        default: _withId(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table, {
                        data: [_ctx.statisticsData.total_task],
                        border: "",
                        size: "small",
                        "header-cell-class-name": "tabelHeader",
                        "cell-class-name": "tabelStyle",
                        style: {"width":"100%","margin-bottom":"50px"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "total_tasks",
                            label: "total_tasks",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "success_tasks",
                            label: "success_tasks",
                            align: "center"
                          })
                        ]),
                        _: 1
                      }, 8, ["data"]),
                      _createVNode(_component_el_divider, { "content-position": "left" }, {
                        default: _withId(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table, {
                        data: _ctx.statisticsData.task_type_summary,
                        border: "",
                        size: "small",
                        "header-cell-class-name": "tabelHeader",
                        "cell-class-name": "tabelStyle",
                        style: {"width":"100%","margin-bottom":"50px"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "type",
                            label: "type",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "type_name",
                            label: "type_name",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "subtype",
                            label: "subtype",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "subtype_name",
                            label: "subtype_name",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "total_tasks",
                            label: "total_tasks",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "success_tasks",
                            label: "success_tasks",
                            align: "center"
                          })
                        ]),
                        _: 1
                      }, 8, ["data"]),
                      _createVNode(_component_el_divider, { "content-position": "left" }, {
                        default: _withId(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table, {
                        data: _ctx.statisticsData.scene_script_summary,
                        border: "",
                        size: "small",
                        "header-cell-class-name": "tabelHeader",
                        "cell-class-name": "tabelStyle",
                        style: {"width":"100%","margin-bottom":"50px"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "scene_id",
                            label: "scene_id",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "scene_name",
                            label: "scene_name",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "script_id",
                            label: "script_id",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "script_name",
                            label: "script_name",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "test_count",
                            label: "test_count",
                            align: "center"
                          })
                        ]),
                        _: 1
                      }, 8, ["data"]),
                      _createVNode(_component_el_divider, { "content-position": "left" }, {
                        default: _withId(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table, {
                        data: _ctx.statisticsData.scene_type_summary,
                        border: "",
                        size: "small",
                        "header-cell-class-name": "tabelHeader",
                        "cell-class-name": "tabelStyle",
                        style: {"width":"100%"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "scene_id",
                            label: "scene_id",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "scene_name",
                            label: "scene_name",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "type",
                            label: "type",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "type_name",
                            label: "type_name",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "subtype",
                            label: "subtype",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "subtype_name",
                            label: "subtype_name",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "test_count",
                            label: "test_count",
                            align: "center"
                          })
                        ]),
                        _: 1
                      }, 8, ["data"])
                    ], 64))
                  : (!_ctx.loading)
                    ? (_openBlock(), _createBlock(_component_el_empty, {
                        key: 1,
                        description: "暂无数据"
                      }))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ], 512), [
            [_directive_loading, _ctx.loading]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})